import Manager from 'coreClasses/Manager';
import CookiesMgr from 'coreClasses/cookies/CookiesMgr';
import {NL_COOKIE_POPUP} from 'brandConstants';

/**
 * Represents NewsletterMgr
 */
class NewsletterMgr extends Manager {
	/**
	 * Initializes the newsletter functionality based on the current route and device type.
	 * @param {object} location - The current location object.
	 * @returns {void}
	 */
	initializeNewsletter(location: any): void {
		const locationUrl = location.href.toLowerCase();
		const configurationsMgr = this.managerRepository.getConfigurationsMgr();
		const enableNewsletterPopup = configurationsMgr.get('sitePreferences.enableNewsletterAutomaticPopup');
		const newsletterPopupTimer = configurationsMgr.get('sitePreferences.newsletterPopupTimer');
		const pagesToExcludeNewsletter = configurationsMgr.get('sitePreferences.pagesToExcludeNewsletter');
		let excludePage = false;

		if (pagesToExcludeNewsletter) {
			const pages = pagesToExcludeNewsletter.split(';');

			for (let i = 0; i < pages.length && !excludePage; i++) {
				const currentPage = pages[i];
				const isHomepage = currentPage === '/homepage' && location.isHomepage;
				const isPLP = currentPage === '/plp' && location.pageType === 'PLP';
				const isPDP = currentPage === '/pdp' && location.pageType === 'PDP';

				if (locationUrl.includes(currentPage) || isHomepage || isPLP || isPDP) {
					excludePage = true;
				}
			}
		}

		if (!enableNewsletterPopup || excludePage) {
			return;
		}

		this.showNewsletter(newsletterPopupTimer);
	}

	/**
	 * Opens the newsletter popup if conditions are met.
	 * @param {number} timer - Time interval (in seconds) for displaying the newsletter popup.
	 * @returns {void}
	 */
	protected showNewsletter(timer: number): void {
		const popupsMgr = this.managerRepository.getPopupsMgr();

		setTimeout(() => {
			const cookieConfig = NL_COOKIE_POPUP;

			if (!CookiesMgr.getCookie(cookieConfig?.cookieName).getValue()) {
				popupsMgr.openPopup('newsletterAutomaticPopup');
			}
		}, timer * 1000);
	}
}

export default NewsletterMgr;
